import { get, post } from "../../utils/httpClient";

const boardService = () => {
  const prefixApi = "duedates/entrypoint";

  const getInfo = async () => {
    return await get(`/${prefixApi}`);
  };

  const createSeedData = async () => {
    return await post(`/${prefixApi}`);
  };

  return {
    getInfo,
    createSeedData,
  };
};

export default boardService;
